"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.max = void 0;
var jsmidgen_1 = require("jsmidgen");
/**
 * Take an array of note objects to populate a clip selected in Ableton Live via Max4Live
 * @param  {NoteObject[]} notes    Notes are in the format: {note: ['c3'], level: 127, length: 64}
 */
var max = function (notes, liveClip) {
    if (liveClip === void 0) { liveClip = 'live_set view highlighted_clip_slot clip'; }
    var liveObject = new LiveAPI(liveClip);
    var totalLength = notes.reduce(function (a, b) {
        return a + b.length;
    }, 0);
    liveObject.set('loop_end', totalLength / 512);
    liveObject.call('remove_notes', 0, 1, 258, 127);
    liveObject.call('set_notes');
    var noteCount = notes.reduce(function (a, b) {
        return (a = a + (b.note ? b.note.length : 0));
    }, 0);
    liveObject.call('notes', noteCount);
    var cursor = 0;
    notes.forEach(function (noteObj) {
        if (noteObj.note) {
            noteObj.note.forEach(function (n) {
                liveObject.call('note', jsmidgen_1.Util.midiPitchFromNote(n), cursor.toFixed(2).toString(), (noteObj.length / 512).toFixed(2).toString(), noteObj.level || 100, 0);
            });
            cursor = cursor + noteObj.length / 512;
        }
        else {
            cursor = cursor + noteObj.length / 512;
        }
    });
    liveObject.call('done');
};
exports.max = max;
